import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'configuraciones/acreedores';

/**
 * GET Acreedores
 * @param {object} id
 * @returns {Promise<object[]>}
 */
export const getAcreedores = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Acreedor
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAcreedor = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Acreedor
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAcreedor = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Acreedor
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAcreedor = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Acreedor
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteAcreedor = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
